import { camelCase, camelCaseCustomProperties, generateCustomDimensionName, getSectionCustomPropertiesDefault, getSegmentField } from ".";
import { PROPERTY_TYPES, REPORT_DATA_TYPES, REPORT_NAMES } from "../constants";
import { MAPPING_PRIMARY_OBJECT_SCOPE, SEVER_SIDE_OBJECT } from "../constants/destinations";
import { SECTION_OPTION_SEGMENT } from "../constants/segment";

export const handleChangeCol = (arr1, arr2) => {
     const colMetrics = arr1.filter((element1) => {
          if (arr2?.length > 0) {
               return arr2.some((element2) => element2.label === element1.label);
          }
          return false;
     });
     return colMetrics;
};

export const handleChangeColV2 = (arr1, arr2) => {
     const colMetrics = arr1.filter((element1) => {
          if (arr2?.length > 0) {
               return arr2.some((element2) => element2.value === element1.key);
          }
          return false;
     });
     return colMetrics;
};

export const handleChangeColSort = (arr1 = [], arr2 = []) => {
     const metricMap = new Map(arr1.map((item) => [item.key, item]));

     return arr2.map((filterItem) => {
          const keyParts = filterItem?.value.split('_') && !filterItem?.value.split('__c');
          const key = keyParts.length > 1 ? keyParts.pop() : filterItem?.value;
          return metricMap.get(key);
     }).filter((item) => item !== undefined);
};

export const handleChangeColSortDimension = (arr1, arr2) => {
     const metricMap = new Map(arr1.map((item) => [item.key, item]));
     return arr2.map((filterItem) => metricMap.get(filterItem.value)).filter((item) => item !== undefined);
};

export function findItemByTargetId(data, targetId) {
     for (const item of data) {
          if (item.id === targetId) {
               return item;
          }
          if (item.children) {
               const nestedItem = findItemByTargetId(item.children, targetId);
               if (nestedItem) {
                    return nestedItem;
               }
          }
     }
     return null;
}

export function findLongestValue(data) {
     if (!data || data.length === 0) return;

     const longestValues = {};

     data.forEach((item) => {
          Object.keys(item).forEach((key) => {
               const value = item[key];
               if (typeof value === 'string') {
                    if (!longestValues[key] || value.length > longestValues[key].length) {
                         longestValues[key] = value;
                    }
               }
          });
     });

     return longestValues;
}

export const filterConversionNameItem = (data, conversionName, segments) => {
     const filterDefaultItems = [];
     const otherItems = [];
     const eCommerceItems = [];
     data.forEach((item) => {
          if (conversionName.find((conversion) => item.label === conversion.label)) {
               if (item.label.includes('Ecommerce')) {
                    eCommerceItems.push(item);
               } else {
                    otherItems.push(item);
               }
          } else if (segments.length) {
               segments.map((seg) => filterDefaultItems.push({
                    "label": item.label,
                    "value": `${getSegmentField(seg.id, item.value)}`
               }))
          } else {
               filterDefaultItems.push(item);
          }
     });

     return [filterDefaultItems, otherItems, eCommerceItems];
};

export const convertNameSegmentSort = ({ sort, listSegmentReportApply }) => {
     if (sort?.fieldName) {
          let field = sort.fieldName.split('_');
          if (listSegmentReportApply.find((seg) => camelCase(seg.id) === field[0])) {
               field = field.filter((el) => el !== field[0])
          }
          return field.join('_')
     }
}

export const changeSortSegment = ({ sort, listSegmentReportApply = [], filterMetric }) => {
     if (sort?.fieldName) {
          const segment = listSegmentReportApply.find((seg) => sort.fieldName.includes(camelCase(seg.id)));
          let field = filterMetric[0].value.split('_') || [];
          if (segment) {
               field.unshift(camelCase(segment.id));
          } else if (listSegmentReportApply?.length > 0) {
               field.unshift(camelCase(listSegmentReportApply[0].id));
          }
          return field.join('_');
     } else {
          const segment = listSegmentReportApply[0];
          let field = filterMetric[0].value.split('_') || [];
          if (segment) {
               field.unshift(camelCase(segment.id));
          }
          return field.join('_');
     }
}

export function formatNumberWithCommas(number) {
     if (number === null) {
          return '0'
     }
     return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') !== 'NaN' ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 'None';
}

export function isNumber(value) {
     return !isNaN(Number(value));
}

export function formatNumber(value) {
     if (typeof value !== 'number') {
          return String(value);
     } else {
          return formatNumberWithCommas(Number(value));
     }
}

export function formatNumberValue(value) {
     if (!isNumber(value)) {
          return String(value);
     } else {
          return formatNumberWithCommas(typeof value === 'number' ? Number(value) : value);
     }
}

export const getCustomPropertiesReport = (customProperties, newProperties, newFilter = [], reportName) => {
     if (![REPORT_NAMES.BY_PROPERTY, REPORT_NAMES.BY_CONVERSION].includes(reportName)) {
          newFilter = [];
     }
     let newCustomProperties = customProperties.filter((el) => newProperties.find((item) => item === el.properties || item === generateCustomDimensionName(el.name)) || newFilter.some((item) => item.type === el.properties)) || [];
     if (newCustomProperties && newCustomProperties?.length > 0) {
          newCustomProperties = newCustomProperties.map((item) => {
               return {
                    pathPropertyName: item.pathPropertyName,
                    properties: item.properties,
                    availableScopes: item?.availableScopes,
                    target: item.target,
                    bigQueryName: item.bigQueryName,
                    id: item.id,
                    dataSource: item.dataSource,
                    name: item.name,
                    eventObjectName: item.eventObjectName,
                    isCustom: item.isCustom,
               };
          });
     }
     return newCustomProperties;
};

export const handleOrderCol = (arr, arrFilter) => {
     const newArr = [];
     arr.forEach((item) => {
          if (arrFilter.some((el) => el.value === item.key)) {
               newArr.push(item.key);
          }
     });
     return newArr;
};

export const isRateField = ({ value, fields }) => {
     let isRateOtherFields = fields?.some((f) => f?.source === value && f?.source.toLocaleLowerCase().includes('probability'));
     return value.includes('Rate') || value.includes('Probability') || isRateOtherFields;
}

export const getCustomPropertyOptions = ({ propertyOptions = [], customDimensions, scopes, object, showTargetAccount }) => {
     const hideNameData = {
          [SEVER_SIDE_OBJECT.PEOPLE]: ['Browser', 'Device Type', 'Continent', 'Country', 'Postal Code', 'Region'],
          [SEVER_SIDE_OBJECT.COMPANY]: ['Exit Page', 'Landing Page', 'Tracking Level', 'Browser', 'Consent Method', 'Regional Consent Rule', 'Continent', 'Device Type'],
     };
     const mappingScopes = { Company: 'Revealed Company', Conversion: 'Web Conversion' };
     const ignoreCustomDimensions = [
          'Session ID',
          'Event ID',
          'Person ID',
          'User ID',
          'Company ID',
          'Identify Strength',
          'Browser',
          'Consent Method',
          'Continent',
          'Country',
          'Device Type',
     ];
     const mappingSections = {
          'Postal Code': SECTION_OPTION_SEGMENT.GEOGRAPHY,
          Region: SECTION_OPTION_SEGMENT.GEOGRAPHY,
          'Target Account Domain': SECTION_OPTION_SEGMENT.TARGET_ACCOUNT
     };
     let options = [];
     const sameNamePropertyArray = [];

     customDimensions.forEach((dimension) => {
          const { name: dimensionName, isCustom, status, availableScopes } = dimension;
          const hideNames = hideNameData[object];

          if (hideNames?.includes(dimensionName)) return;

          let isSameNameProperty = false;
          const disableTargetAccount = !showTargetAccount && dimensionName === 'Target Account Domain';
          const currentScope = MAPPING_PRIMARY_OBJECT_SCOPE[object] || object;
          const mappingScope = mappingScopes[currentScope] ?? currentScope;
          const validScopeConfig = availableScopes.find((item) => {
               const scope = scopes.find((el) => el.id === item.id);

               if (scope) {
                    return scope.name.includes(mappingScope);
               }

               return item.id === mappingScope;
          });

          if (validScopeConfig && customDimensions.find((el) => !isCustom && el.name !== dimensionName && camelCase(el.name) === camelCase(dimensionName))) {
               sameNamePropertyArray.push(dimension);
          }

          if (sameNamePropertyArray.length > 1) {
               // name custom report dup or many dup
               const searchTerm = camelCase(dimensionName);
               const searchRegex = new RegExp(searchTerm, 'i');
               const occurrences = sameNamePropertyArray.filter((obj) => Object.values(obj).some((value) => typeof value === 'string' && value.match(searchRegex)));

               if (occurrences.length > 1) {
                    isSameNameProperty = true;
               }
          }

          const isValidProperty =
               validScopeConfig &&
               !propertyOptions.some((el) => !isCustom && (el.label === dimensionName || el.value === camelCase(dimensionName))) &&
               !isSameNameProperty &&
               !disableTargetAccount &&
               !ignoreCustomDimensions.includes(dimensionName);

          if (isValidProperty && status) {
               const propertyValue = camelCaseCustomProperties(dimensionName);
               const sectionProperty = getSectionCustomPropertiesDefault(dimension, currentScope);
               const customPropertyOption = {
                    section: mappingSections[dimensionName] || (!isCustom && sectionProperty?.section ? sectionProperty?.section : SECTION_OPTION_SEGMENT.CUSTOM_PROPERTIES),
                    sectionParent: !isCustom && sectionProperty?.sectionParent ? sectionProperty?.sectionParent : '',
                    value: propertyValue,
                    label: dimensionName,
                    customDimensionId: dimension.id,
                    propertyData: {
                         bigQueryName: dimension.bigQueryName,
                         dataSource: dimension.dataSource,
                         eventObjectName: dimension.eventObjectName,
                         id: dimension.id,
                         name: dimensionName,
                         pathPropertyName: dimension.pathPropertyName,
                         properties: propertyValue,
                         target: dimension.target || validScopeConfig?.target
                    },
               };

               options.push(customPropertyOption);
          }
     });

     return options.sort((a, b) => a.value.localeCompare(b.value));
};

export const getDefaultFieldReport = ({ reportType, reportName, scoped, weight = [], utmArray = [], properties = [], dimensions = [], objectID, eCoItemCategories = [], customExternalObjectReport, handleGetOption }) => {
     let { metrics, metricsOptional } = reportType ? REPORT_DATA_TYPES[reportName][scoped] : REPORT_DATA_TYPES[reportName];
     let dimensionsDefault = [...dimensions];
     let propertiesDefault = [...properties];
     let metricsDefault = [...metrics];
     let dimensionExternal = [];
     if (reportName === REPORT_NAMES.CONVERSION_SOURCE_ATTRIBUTION_REPORT) {
          dimensionsDefault = [...dimensionsDefault, ...utmArray];
          metricsDefault = handleGetOption({ option: metricsDefault, type: 'weight', reportName, weight });
     }
     if (reportName === REPORT_NAMES.ECOMMERCE_ITEMS) {
          dimensionsDefault = [...dimensionsDefault, ...eCoItemCategories];
     }

     if (reportName === REPORT_NAMES.CUSTOM_EXTERNAL_OBJECT) {
          const externalObject = customExternalObjectReport.find((item) => item.id === objectID);

          if(externalObject?.characteristicHasRevenue) {
               metricsDefault = [...metricsDefault, ...(metricsOptional[PROPERTY_TYPES.REVENUE] || [])];
          }
     }
     return {dimensionsDefault, propertiesDefault, metricsDefault, dimensionExternal};
};

export const handleAssignKeyForDataReport = ({rows, dimensions, properties, metrics, listSegmentReportApply, isCompare = false}) => {
     const returnRows = rows.map((row) =>
          Object.entries(row).reduce((newRow, [compoundKey, compoundValue]) => {
               let fieldValues = [];
               let keyCompound;

               switch (compoundKey) {
                    case 'dimensionCompoundValues':
                         keyCompound = dimensions;
                         break;
                    case 'metricCompoundValues':
                         let newDataMetric = [];

                         if (listSegmentReportApply.length > 0) {
                              metrics?.forEach((i) => {
                                        listSegmentReportApply.forEach((item) => {
                                             newDataMetric.push(getSegmentField(item.id, i));
                                             if(isCompare) {
                                                  newDataMetric.push(`${getSegmentField(item.id, i)}Compare`);
                                             }
                                        });
                                   });
                         } else if(isCompare) {
                              metrics.forEach((i) => {
                                        newDataMetric.push(i);
                                        newDataMetric.push(`${i}Compare`);
                              });
                         } else {
                              newDataMetric = [...metrics];
                         }

                         keyCompound = newDataMetric;
                         break;
                    case 'propertyCompoundValues':
                         keyCompound = properties;
                         break;
                    default:
               }
               // Merge all compoundValues into 1 object
               fieldValues = compoundValue.reduce((prevVal, currentVal, i) => {
                    if (i <= keyCompound.length - 1) {
                         const splitKey = keyCompound[i].split('_');
                         const newKey = splitKey.length > 1 ? splitKey[1] : splitKey[0];
                         let personIdData = {};

                         if (newKey === 'personCreatedCount') {
                              const personIdKey = splitKey.length > 1 ? `${splitKey[0]}_personId` : 'personId';

                              personIdData = { [personIdKey]: currentVal.personId };
                         }

                         return { ...prevVal, [keyCompound[i]]: currentVal.value, ...personIdData };
                    } else {
                         return { ...prevVal };
                    }
               }, {});

               const primaryObject = compoundValue.find((item) => item?.primaryObjectClick)
               const dataSourceObject = compoundValue.find((item) => 'dataSourceValue' in item)

               fieldValues = {...fieldValues, ...(primaryObject?.primaryObjectClick && {primaryObjectClick: primaryObject?.primaryObjectClick})}
               
               if (dataSourceObject) {
                    fieldValues = {...fieldValues, dataSourceValue: dataSourceObject.dataSourceValue}
               }
               
               return { ...newRow, ...fieldValues };
          }, {})
     );
     return returnRows
};

export const sanitizeTableName = (name, maxLength = 128) => {
     if (!name) return '';

     let clean = name.replace(/\s+/g, '_');
     clean = clean.replace(/[^a-zA-Z0-9_]/g, '');
     clean = clean.replace(/_+/g, '_');
     clean = clean.replace(/^_+|_+$/g, '');

     if (/^\d/.test(clean)) {
          clean = 't_' + clean;
     }

     if (clean.length > maxLength) {
          clean = clean.substring(0, maxLength);
     }

     return clean;
};